module.exports = __webpack_public_path__ + "static/media/15.011.d93f4c0e.jpg";